export function ChevronDown() {
  return (
    <path
      d="M7.60001 6.19999L12.8 0.99999C13.0445 0.755547 13.3556 0.633324 13.7333 0.633324C14.1111 0.633324 14.4222 0.755547 14.6667 0.99999C14.9111 1.24444 15.0333 1.55555 15.0333 1.93332C15.0333 2.3111 14.9111 2.62221 14.6667 2.86666L8.53334 8.99999C8.40001 9.13332 8.25557 9.22799 8.10001 9.28399C7.94446 9.33999 7.77779 9.36755 7.60001 9.36666C7.42223 9.36577 7.25557 9.33821 7.10001 9.28399C6.94446 9.22977 6.80001 9.1351 6.66668 8.99999L0.533346 2.86666C0.288901 2.62221 0.166677 2.3111 0.166677 1.93332C0.166677 1.55555 0.288901 1.24444 0.533346 0.999989C0.77779 0.755546 1.0889 0.633324 1.46668 0.633324C1.84446 0.633324 2.15557 0.755546 2.40001 0.999989L7.60001 6.19999Z"
      fill="currentColor"
    />
  )
}
export default ChevronDown
